// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___8787069a15302e4862b","cls2":"ImpactHubModal-cls2__bc8c550221498e4a0c70 ImpactHubModal-cls1___8787069a15302e4862b"};